import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const ExportSheet = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 16 16">
    <path
      id="Vector"
      d="M9.33329 1.3335H3.99996C3.25996 1.3335 2.66663 1.9335 2.66663 2.66683V13.3335C2.66663 14.0735 3.25996 14.6668 3.99996 14.6668H12C12.74 14.6668 13.3333 14.0735 13.3333 13.3335V5.3335L9.33329 1.3335ZM12 13.3335H3.99996V2.66683H8.66663V6.00016H12V13.3335ZM8.59996 9.66683L10.5333 12.6668H9.33329L7.99996 10.4002L6.66663 12.6668H5.46663L7.39996 9.66683L5.46663 6.66683H6.66663L7.99996 8.9335L9.33329 6.66683H10.5333L8.59996 9.66683Z"
    />
  </SvgIcon>
));

ExportSheet.displayName = 'ExportSheet';

export default ExportSheet;
